import { render, staticRenderFns } from "./DivisionDropdown.vue?vue&type=template&id=33094b99&"
import script from "./DivisionDropdown.vue?vue&type=script&lang=js&"
export * from "./DivisionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33094b99')) {
      api.createRecord('33094b99', component.options)
    } else {
      api.reload('33094b99', component.options)
    }
    module.hot.accept("./DivisionDropdown.vue?vue&type=template&id=33094b99&", function () {
      api.rerender('33094b99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/DivisionDropdown.vue"
export default component.exports